var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColorPicker',_vm._b({staticClass:"AppColorPicker",on:{"input":_vm.onChange}},'ColorPicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }